module.exports = {
  //端口
  port: "8092",
  gaode: {
    key: "34e07dd669bd6484fd5ac2d571656a1a",
  },
  google: {
    key: "AIzaSyDSyzj7bdbQXomryC1nhfqRbW99o7SugIk",
  },
  web: "1.2.1",
  sdk: "40.0.0.0",
  //账户类型值分为：phone（手机），email（邮箱），all（手机和邮箱）
  accountType: "email",
  //通过经纬度获取地址插件的key
  openweathermapKey: "2ff710adbb6eef2974e10f50477dc334",
  //蓝牙前缀与设备类型
  ModelList: [
    {
      key: "keyBox",
      model: ["RESCS03077"],
    },
    {
      key: "dLock",
      model: ["RD070"],
    },
    {
      key: "cLock",
      model: ["RC08001", "RB06"],
    },
    //密码盘
    {
      key: "passwordDisk",
      model: ["RC02028"],
    },
    {
      key: "nbLidMonitor",
      model: ["RB0204011111"],
    },
    {
      key: "nbLidLock",
      model: ["RB0204011111"],
    },
    //网络编码器
    {
      key: "hotPoint",
      model: ["RB02040", "RC02032", "RC02035", "RC02039"],
    },
    {
      key: "passiveLock",
      model: ["B0345", "B0344", "B0343"],
    },
    {
      key: "bleKey",
      model: ["B03"],
    },
    {
      key: "keyMiniBox",
      model: ["RC03102", "RC03012"],
    },
    //钥匙管理箱
    {
      key: "keyManageBox",
      model: ["RS03102"],
    },
    //蓝牙门禁
    {
      key: "bleDoorLock",
      model: ["RC03038"],
    },
  ],
  //主菜单激活选项(不激活)
  sidebarInactive: ["personalInfo"],
  //主菜单激活对应选项(激活)
  sidebarActive: [
    {
      active: "site",
      range: ["siteCreate", "siteEdit"],
    },
    {
      active: "systemGroup",
      range: ["systemGroupCreate", "systemGroupEdit"],
    },
    {
      active: "systemRole",
      range: ["systemRoleCreate", "systemRoleEdit"],
    },
  ],
  //表格记录条数(-1:不限制，按浏览器中表格显示高度计算)
  tableLimit: -1,
  //软件名称
  softwareName: "Evo Key",
  //账号默认密码
  password: "password",
  //角色权限
  role: {
    workbench: {
      gis: true,
      userPermission: true,
      devicePermission: true,
      crosstab: true,
    },
    user: {
      web: true,
      create: true,
      find: true,
      edit: true,
      delete: true,
    },
    site: {
      create: true,
      find: true,
      edit: true,
      delete: true,
    },
    device: [
      {
        deviceModel: "",
        create: true,
        find: true,
        edit: true,
        delete: true,
        setting: true,
        install: true,
        permission: {
          ble: {
            create: true,
            find: true,
            edit: true,
            delete: true,
          },
          card: {
            create: true,
            find: true,
            edit: true,
            delete: true,
          },
          pinCode: {
            create: true,
            find: true,
            edit: true,
            delete: true,
          },
          tempCode: {
            create: true,
            find: true,
            edit: true,
            delete: true,
          },
          key: {
            create: true,
            find: true,
            edit: true,
            delete: true,
          },
        },
      },
    ],
    report: {
      create: true,
      find: true,
      edit: true,
      delete: true,
    },
    system: {
      area: {
        create: true,
        find: true,
        edit: true,
        delete: true,
      },
      role: {
        create: true,
        find: true,
        edit: true,
        delete: true,
      },
      department: {
        create: true,
        find: true,
        edit: true,
        delete: true,
      },
      project: {
        create: true,
        find: true,
        edit: true,
        delete: true,
      },
      template: {
        create: true,
        find: true,
        edit: true,
        delete: true,
      },
    },
  },
  //是否开启国内测试版本 包括用户组 用户整组授权等新功能
  test: false,
  //下载链接路径后缀，部署上去的版本有会在接口地址后面加这个特殊路径 /sectel
  downloadUrl: "",
  //企业版 Enterprise 设备中站点为必填项  家庭版Home  设备中站点为非必填项
  mode: "Home",
  //en 英文 nb 挪威 he希伯来语  de德语
  language: "en",
  title: "Evo Key", //浏览器标题
  projectid: "62e721ceb86927045725dbd3", // 6260cdb059e78848d46e6512  62e721ceb86927045725dbd3
  adminId: "623a698f9a0df321fd1801c2", //623a698f9a0df321fd1801c2 62441c293a050632bc8b3b2c  641cfc7d3d08984438b5b26e
};



//////////////////
// WEBPACK FOOTER
// ./static/config/param.js
// module id = yxA3
// module chunks = 25